import React from "react";
import { Button } from "reactstrap";
import whiteCrossIcon from "../../../../assets/images/buttons/whiteCrossIcon.svg";
import blackCrossIcon from "../../../../assets/images/buttons/blackCrossIcon.svg";
import disabledCrossIcon from "../../../../assets/images/buttons/disabledCrossIcon.svg";
import "./Buttons.scss"; // Use a common SCSS file for styling
const Buttons = ({
  children,
  color,
  onClick,
  iconPosition,
  disabled,
  buttonType, // New prop to handle button type (e.g., "secondary", "ghost","primary")
  size, //regular and small
  image,
  dimensions, //normal or responsive
  width,
  // Other props as needed
  ...rest
}) => {
  const renderIcon = () => {
    const icon = disabled
      ? disabledCrossIcon
      : buttonType == "primary"
      ? whiteCrossIcon
      : blackCrossIcon;
    const marginRight = iconPosition === "left" ? { marginRight: "8px" } : {};
    const marginLeft = iconPosition === "right" ? { marginLeft: "8px" } : {};
    const width = size == "small" ? { width: "16px" } : {};
    const height = size == "small" ? { height: "16px" } : {};
    return (
      <img
        src={image || icon}
        style={{
          ...marginRight,
          ...marginLeft,
          ...width,
          ...height,
        }}
        alt="Cross Icon"
      />
    );
  };
  return (
    <Button
      //className={`genericButton ${buttonType}`} // Apply a common class for styling
      className={`${
        dimensions === "normal"
          ? size == "regular"
            ? buttonType == "primary"
              ? "regularPrimaryButton"
              : buttonType == "secondary"
              ? "regularSecondaryButton"
              : "regularGhostButton"
            : size == "small"
            ? buttonType == "primary"
              ? "smallPrimaryButton"
              : buttonType == "secondary"
              ? "smallSecondaryButton"
              : "smallGhostButton"
            : ""
          : dimensions === "responsive"
          ? size === "small"
            ? buttonType == "primary"
              ? "responsiveSmallPrimaryButton"
              : buttonType == "secondary"
              ? "responsiveSmallSecondaryButton"
              : "responsiveSmallGhostButton"
            : size === "regular"
            ? buttonType == "primary"
              ? "responsiveRegularPrimaryButton"
              : buttonType == "secondary"
              ? "responsiveRegularSecondaryButton"
              : "responsiveRegularGhostButton"
            : ""
          : ""
      }`} // Apply a common class for styling
      style={{ color: color, width: width }}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {iconPosition === "left" && renderIcon()}
      {children}
      {iconPosition === "right" && renderIcon()}
    </Button>
  );
};

export default Buttons;
